import React from 'react';
import '../css/contact.css';

function Contact(){
    const onSubmit = async (event) =>{
        event.preventDefault();

        console.log("SUBMITTED");

        //CONVERT FROM DATA TO JSON
        const formData = new FormData(event.target);
        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);

        console.log(json);

        //PASS JSON TO BACKEND
        try{
            const response = await fetch("http://localhost:8000/api/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: json,
            });

            const result = await response.json();

            if(result.sucess){
                console.log("Sucess", result);
            }else{
                console.log("Failed to send email", result);
            }
        } catch (err){
            console.error("Network or Server Error", err);
        }
    };

    return(
        <section className="Contact">
            <form onSubmit={onSubmit}>
                <h2>Let me help tell your story!</h2>
                <div className='input-box'>
                    <label>Full Name</label>
                    <input type="text" name="name" className='field' placeholder='Enter your name' required></input>
                </div>
                <div className='input-box'>
                    <label>Email Address</label>
                    <input type="email" name="email" className='field' placeholder='Enter your email' required></input>
                </div>
                 <div className='input-box mess'>
                    <label>Your Message</label>
                    <textarea type="text" className="field mess" name="message" id="" placeholder="Enter your message"></textarea>
                </div>
                <button type="submit">Send Message</button>

            </form>
        </section>
    )

}

export default Contact;

















// import React, {useRef} from 'react';
// import emailjs from '@emailjs/browser';

// export const Contact = () =>{

//     const form = useRef();

//     const sendEmail = (e) => {
//         e.preventDefault();
//     }

//     emailjs.sendForm('SERVICE_ID', 'TEMPLATE_ID', form.current, 'PUBLIC_KEY')
//         .then((result) => {
//             console.log(result.text);
//         }, (error) => {
//             console.log(error.text);
//         });

//     return(
//         <form ref={form} onSubmit={sendEmail}>
//             <label>Name</label>
//             <input type="text" name="user_name"/>
//             <label>Email</label>
//             <input type="email" name="user_email"/>
//             <label>Message</label>
//             <textarea name="message"/>
//             <input type="submit" value="Send"/>

//         </form>
//     )

// }

// export default Contact;